import React, { useRef } from 'react';
import StockDetailsQuickActions from './stockDetails/StockDetailsQuickActions';
import BatchDetailsQuickActions from './batchDetails/BatchDetailsQuickActions';
import StudentInformationQuickActions from './studentInformation/StudentInformationQuickActions';
import RemarkReminderReset from './paymentSummary/RemarkReminderReset';
import { useGetPermissions } from 'layouts/customHook';

const QuickActions = ({
  activeTab,
  studentDetails,
  fetchStudentDetails = () => {},
  fetchApplications = () => {},
  setApiLoader = () => {},
  activeApplicationDetails,
}) => {
   
  const userPermissions = useGetPermissions('outstandingfees');
  const actionsMap = {
    // studentInformation: (
    //   <StudentInformationQuickActions activeApplicationDetails={activeApplicationDetails} fetchApplications={fetchApplications} />
    // ),
    batchDetails: (
      <BatchDetailsQuickActions
        studentDetails={studentDetails}
        fetchStudentDetails={fetchStudentDetails}
        fetchApplications={fetchApplications}
        setApiLoader={setApiLoader}
        activeApplicationDetails={activeApplicationDetails}
      />
    ),
    stockDetails: (
      <StockDetailsQuickActions
        activeApplicationDetails={activeApplicationDetails}
      />
    ),
    paymentSummary:(
      useGetPermissions?
    <RemarkReminderReset 
      studentDetails={studentDetails} 
      activeApplicationDetails={activeApplicationDetails}
      setApiLoader={setApiLoader}
      userPermissions={userPermissions}
    />:<></>)
  };

  return (
    <div>
      {actionsMap[activeTab] && (
        <h3 className='mb-3' style={{ fontSize: '20px' }}>
          Quick action
        </h3>
      )}
      <div>
        {actionsMap[activeTab] || null}
      </div>
    </div>
  );
};

export default QuickActions;
